import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { APP_CONFIG } from '@/constants/branding';

const CertificatePreview = ({ name, program, date }) => {
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  
  useEffect(() => {
    QRCode.toDataURL('https://provatio.com.br/verify/preview')
      .then(url => setQrCodeUrl(url))
      .catch(err => console.error(err));
  }, []);

  const formattedDate = date ? new Date(date).toLocaleDateString('pt-BR') : new Date().toLocaleDateString('pt-BR');

  return (
    <div className="cert-preview-container">
      <div className="certificate-layout" style={{ minWidth: '297mm', minHeight: '210mm' }}>
        <div className="cert-header">
          <img src={APP_CONFIG.LOGO_URL} alt="PROVATIO Logo" className="cert-logo" />
          <div className="text-right text-[#1a3a52]">
            <p className="text-xs m-0">República Federativa do Brasil</p>
            <p className="text-xs font-bold m-0">{APP_CONFIG.APP_NAME}</p>
          </div>
        </div>
        
        <div className="cert-body">
          <h1 className="cert-title">Certificado</h1>
          <h2 className="cert-subtitle">Certificação Profissional</h2>
          
          <p className="cert-text">Certificamos que</p>
          <h3 className="cert-name">{name || '[Nome do Profissional]'}</h3>
          <p className="cert-text">concluiu com êxito os requisitos do programa de</p>
          <h4 className="cert-program">{program || '[Programa de Certificação]'}</h4>
          <p className="cert-text mt-4">comprovando proficiência técnica e conhecimentos específicos na área.</p>
        </div>

        <div className="cert-footer">
          <div className="cert-signature">
            <div className="cert-signature-line h-10"></div>
            <p className="font-bold text-[#1a3a52] m-0">Diretoria de Certificação</p>
            <p className="text-xs text-slate-500 m-0">{APP_CONFIG.APP_NAME}</p>
          </div>
          
          <div className="text-center">
            <p className="text-[#1a3a52] font-medium mb-2">Emitido em: {formattedDate}</p>
            {qrCodeUrl && <img src={qrCodeUrl} alt="QR Code Preview" className="cert-qrcode mx-auto" />}
            <p className="cert-id">Código: PRV-XXXXXXXX-XXXX</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificatePreview;